import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import PageNotFound from 'views/PageNotFound';

export default function ProtectedRoute({ prefix, children }) {
    const customization = useSelector((state) => state.customization);
    // alert(JSON.stringify(customization?.userInfo));
    const authToken = customization?.userInfo?.token || localStorage.getItem('token') != null;
    const userInfo = customization?.userInfo || JSON.parse(localStorage.getItem('userInfo'));

    // Check if the role or accountType matches the prefix
    const isAuthenticated = !!authToken;
    const userRole = userInfo?.role || userInfo?.accountType;
    const administrativeRoles = ['admin', 'finance', 'manager', 'support'];

    let hasPermission = false;
    if (prefix === 'admin') {
        hasPermission = administrativeRoles.includes(userRole);
    } else if (prefix === 'vendor') {
        hasPermission = userRole === 'vendor' || userRole === 'staff';
    } else {
        hasPermission = userRole === prefix;
    }

    return isAuthenticated ? hasPermission ? children : <PageNotFound /> : <Navigate to="/login" replace={true} />; // Redirect to login if not authenticated
}
